document.addEventListener("DOMContentLoaded", function() {
    const qnaNavs = document.querySelectorAll(".FaqSummary .FaqSummary__Item");
    const faqContainer = document.querySelector(".Faq");
    qnaNavs.forEach(navItem => {
      navItem.addEventListener("click", function(e) {
        qnaNavs.forEach(item => item.classList.remove("is-active"));
        this.classList.add("is-active");
      });
    });
    if (faqContainer) {
      faqContainer.addEventListener("click", function(event) {
        const button = event.target.closest(".Faq__Question");
        if (!button) return;

        const buttonToggle = button.closest(".Faq__Item");
        const containerContent = button.nextElementSibling;
        if (!buttonToggle || !containerContent) return;
        document.querySelectorAll(".Faq__Item.opened").forEach(toggle => {
          if (toggle !== buttonToggle) {
            toggle.classList.remove("opened");
            toggle.querySelector(".Faq__AnswerWrapper").style.maxHeight = null;
          }
        });
        buttonToggle.classList.toggle("opened");
        containerContent.style.maxHeight = containerContent.style.maxHeight
          ? null
          : `${containerContent.scrollHeight}px`;
      });
    }
  });